import React, { FC } from 'react'
import {
  BreadcrumbsModule,
  GiftImageCarouselModule,
  KlarnaInfoModule,
  OfferBannerModule,
  PriceModule,
  ProductPillsModule,
  ProductSellingPointsModule,
  ProductTitleModule,
  RatingModule,
  SelectCardCTAModule,
  USPModule,
  VariantSelectorModule,
} from '../../modules'
import { Box, Flex } from '@moonpig/launchpad-components'

export const DigitalGiftTop: FC = () => {
  return (
    <div data-testid="mp-find-digital-gift-details">
      <OfferBannerModule width={1} />
      <BreadcrumbsModule withContainer />
      <Flex
        flexWrap="wrap"
        justifyContent="center"
        px={{ xs: 0, md: 8 }}
        gap={8}
      >
        <GiftImageCarouselModule
          flex={1}
          width={{ xs: 1, md: 1 / 2 }}
          maxWidth="600px"
          withContainer
        />
        <Box flex={1} width={{ xs: 1, md: 1 / 2 }} maxWidth="600px">
          <ProductTitleModule withContainer mb={8} />
          <RatingModule withContainer />
          <PriceModule withContainer mb={8} />
          <USPModule withContainer mb={8} />
          <VariantSelectorModule withContainer mb={8} />
          <ProductPillsModule withContainer mb={8} />
          <KlarnaInfoModule withContainer mb={8} />
          <ProductSellingPointsModule mb={8} />
          <SelectCardCTAModule withContainer />
        </Box>
      </Flex>
    </div>
  )
}
